export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 列表
    getIpList: function getIpList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/ip/get",
        method: "get",
        params: data
      });
    },
    getLocationByIp: function getLocationByIp() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/ip/getLocation",
        method: "post",
        data: data
      });
    },
    getLocationByUserId: function getLocationByUserId() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/ip/getLocationByUserId",
        method: "get",
        params: data
      });
    },
    // 获取高危ip
    getIpStatus: function getIpStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/api/resource/ip/black/ip/list",
        method: "get",
        params: data
      });
    },
    // 设置高危ip
    setIpStatus: function setIpStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/api/resource/ip/black/ip/list",
        method: "post",
        data: data
      });
    },
    getBlackIpByUser: function getBlackIpByUser() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/api/resource/ip/black/ip/matching/by/user",
        method: "get",
        params: data
      });
    },
    getIpInfo: function getIpInfo() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/getIpInfo",
        method: "get",
        params: data
      });
    }
  };
});